import React from 'react';
import { Link } from 'react-router';

const CategoryLink = ({ className, item, onClick, children }) =>
	item.externalUrl ? (
		<a
			className={className}
			href={item.externalUrl}
			target="_blank"
			rel="noopener noreferrer"
			onClick={onClick}
		>
			{children}
		</a>
	) : (
		<Link className={className} to={`/product?category_id=${item.id}`} onClick={onClick}>
			{children}
		</Link>
	);

export default CategoryLink;
